import { render, staticRenderFns } from "./OneTimePassword.vue?vue&type=template&id=3686cd9b&scoped=true&"
import script from "./OneTimePassword.vue?vue&type=script&lang=ts&"
export * from "./OneTimePassword.vue?vue&type=script&lang=ts&"
import style0 from "./OneTimePassword.vue?vue&type=style&index=0&id=3686cd9b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3686cd9b",
  null
  
)

export default component.exports